export default __webpack_public_path__ + "static/media/drone6.1fd81ee9.jpg";